export default "__VITE_ASSET__DxzBOAth__"